import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {Link} from 'react-router-dom';

import axios from 'axios'
import querystring from 'querystring'

import $ from 'jquery'

import {
    setPackagingType,
    setProduct
} from '../../modules/order'

import {
    addProduct
} from '../../modules/cart'

import RadioFormType from './../../components/RadioFormType';

class PackagingType extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            mobile_product_info: false
        };
    }

    componentDidMount() {
        ReactDOM.findDOMNode(this).scrollIntoView();
    }

    onPackagingTypeChanged(value){
        this.props.setPackagingType({
            packaging_type: value
        });

        this.getProduct(value);
    }

    getProduct(packaging_type){

        const _this = this;

        axios.post(_this.props.config.api_path+'api/getProduct', querystring.stringify({
            product_type: this.props.order.product_type,
            connector_type: this.props.order.connector_type,
            fiber_type: this.props.order.fiber_type,
            cable_type: this.props.order.cable_type,
            cable_length: this.props.order.cable_length,
            packaging_type: packaging_type,
            optional_attributes: this.props.order.optional_attributes,
            price_tier: this.props.user.price_tier
        }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function (response) {
            _this.props.setProduct({
                product: response.data.product
            })

            _this.setState({
                mobile_product_info: true
            })
        })
        .catch(function (error) {
            console.log(error);
        });
    }

    onAddToCart(){

        var product = $.extend(true, {}, this.props.order.product);
        product.quantity = this.props.order.quantity;
        product.product_type = this.props.order.product_type;

        this.props.addProduct({
            product: product
        });

        $(".basket").removeClass("wobble");
        $(".basket").addClass("wobble");

        this.hide_mobile_product_info();

        const _this = this;

        setTimeout(function () {
            _this.updateSessionCart();
        }, 1000);

    }

    updateSessionCart(){

        const _this = this;

        axios.post(_this.props.config.api_path+'updateSessionCart', querystring.stringify({
            cart: JSON.stringify(this.props.cart.items)
        }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function (response) {

        })
        .catch(function (error) {
            console.log(error);
        });
    }

    hide_mobile_product_info() {
        this.setState({
            mobile_product_info: false
        })
    }

    showProductDetails() {
        this.hide_mobile_product_info();
        $('.extender').fadeToggle();
    }

    render()
    {
        return(
            <div>
                {this.state.mobile_product_info &&
                    <div className="product-info">

                        <div className="closer" onClick={() => this.hide_mobile_product_info()}>
                            <i className="fa fa-times"></i>
                        </div>

                        <div className="content">

                            {this.props.order.product !== null &&
                                <div>Your product: {this.props.order.product.number}<br /> <br /></div>
                            }

                            {this.props.order.product !== null && this.props.user.user !== null ?
                                <div>
                                    <button type="button" onClick={() => this.onAddToCart()}>Add product to cart »
                                    </button>
                                    <br /><br />
                                    <Link to="/OptionalAttributes" className="a_button">
                                        <button type="button" className="background_button">Or: Choose your options »</button>
                                    </Link>
                                </div>
                                :
                                <div>
                                    <button type="button" onClick={() => this.showProductDetails()}>« Your cable is now specified »</button><br /><br />
                                    <Link to="/OptionalAttributes" className="a_button">
                                        <button type="button" className="background_button">Next: Choose your options »</button>
                                    </Link>
                                </div>
                            }

                        </div>
                    </div>
                }
                <div className="content-container">
                    <div className="content">
                        <div className="configurator_form">
                            <div className="row">
                                <h2>2.5 Packaging</h2>
                                <p>Select the packaging you desire.</p>
                                {this.props.packagingTypes.items.length > 0 &&
                                <RadioFormType items={this.props.packagingTypes.items} input_name="packaging_type"
                                               onTypeChanged={(value) => this.onPackagingTypeChanged(value)} checked={this.props.order.packaging_type}/>
                                }
                            </div>
                            {this.props.order.packaging_type !== null &&
                            <div>
                                <div className="hr"></div>
                                <div className="align-right">

                                        {this.props.order.product !== null && this.props.user.user !== null ?
                                            <div>
                                                <button type="button" onClick={() => this.onAddToCart()}>Add product to cart »
                                                </button><br /><br />
                                                <Link to="/OptionalAttributes" className="a_button">
                                                    <button type="button" className="background_button">Or: Choose your options »</button>
                                                </Link>
                                            </div>
                                            :
                                            <div>
                                                <button type="button" onClick={() => this.showProductDetails()}>« Your cable is now specified »</button><br /><br />
                                                <Link to="/OptionalAttributes" className="a_button">
                                                    <button type="button" className="background_button">Next: Choose your options »</button>
                                                </Link>
                                            </div>
                                        }
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    config: state.config,
    packagingTypes: state.packagingTypes,
    order: state.order,
    user: state.user,
    cart: state.cart
})

const mapDispatchToProps = dispatch => bindActionCreators({
    setPackagingType,
    setProduct,
    addProduct
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PackagingType)


// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/containers/PackagingType/index.js